import {
    FAILED_TO_GET_SOLICITOR_IMAGES, GET_IMAGE_FILE, GET_SOLICITOR_IMAGES, INCREMENT_IMAGE_COUNTER, RECEIVE_IMAGE_FILE,
    RECEIVE_SOLICITOR_IMAGES
} from "./index";

//action that increments the fetched images counter
export function incrementImageCounter(imageIndex) {
    return {
        type: INCREMENT_IMAGE_COUNTER,
        payload: imageIndex
    }
}


//action that requests get image file
export function getImageFile(url) {
    return {
        type: GET_IMAGE_FILE,
        payload: url
    }
}

//action that receives image file
export function receiveImageFile(img) {
    return {
        type: RECEIVE_IMAGE_FILE,
        payload: img
    }
}

//action that requests get the solicitor home page images
export function getSolicitorImages() {
    return {
        type: GET_SOLICITOR_IMAGES
    }
}

//action that receives the solicitor images
export function receiveSolicitorImages(images) {
    return {
        type: RECEIVE_SOLICITOR_IMAGES,
        payload: images
    }
}

//action that receives failed response from getting the solicitor images
export function failedToGetSolicitorImages(response) {
    return {
        type: FAILED_TO_GET_SOLICITOR_IMAGES,
        payload: response
    }
}